<script>
import OrderList from '../OrderList'
export default {
  name: 'new-orders',
  extends: OrderList,
  computed: {
    tabOrder () {
      return this.$store.getters.newOrders
    },
    refreshMethod () {
      return 'getNewOrders'
    }
  },
  mounted () {
    // if (this.$store.getters.newOrders.length === 0) {
    this.$store.dispatch('getNewOrders')
    // }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?78f35c3e